/*------------------------------------*\
    DEVHUB APP ROUTER

    Auto-initialises devhub modules based on DOM context.
    Loaded only on devhub pages via wp_enqueue_script.

    Modules are in theme/devhub/scripts/modules/ and are
    concatenated before this file by the Gulp build.

    AJAX credentials are passed via wp_localize_script as devhubAjax:
        devhubAjax.ajaxUrl         — admin-ajax.php URL
        devhubAjax.designNonce     — devhub_design_action nonce
        devhubAjax.templateNonce   — devhub_template_action nonce
        devhubAjax.componentNonce  — devhub_component_action nonce
\*------------------------------------*/

(function ($) {

    $(function () {

        // ── Mockup + component preview iframes ──────────────────
        //
        // Both the single-view iframe (.js-prototype-frame) and the grid
        // card iframes (.devhub-prototype-preview__frame) render mockup
        // HTML that was authored at a fixed 1440px width. Two rendering
        // paths converge here:
        //
        //   1. Grid cards: fixed 1440×900 iframe scaled by transform:scale()
        //      to fit the card width. Container aspect-ratio caps the
        //      visible slice — the iframe overflow is hidden.
        //   2. Single view: fixed 1440-wide iframe scaled to the wrap
        //      width; wrap height set to the scaled content-height so the
        //      whole mockup shows without horizontal overflow.
        //
        // Rebinds on tf:hub-tab-swapped so cards inserted by the AJAX
        // tab swap get scaled too (the old code ran once at DOM ready).

        function tfScaleGridPreview($wrap) {
            var $frame = $wrap.find('.devhub-prototype-preview__frame');
            if (!$frame.length) {
                return;
            }
            var containerWidth = $wrap.width();
            if (!containerWidth) {
                return;
            }
            var scale = containerWidth / 1440;
            $frame.css('transform', 'scale(' + scale + ')');
        }

        function tfScaleGridPreviews($root) {
            var $scope = $root && $root.length ? $root : $(document);
            $scope.find('.devhub-prototype-preview').each(function () {
                tfScaleGridPreview($(this));
            });
        }

        function tfFitSingleFrame($frame) {
            // Give the iframe a fixed 1440px width so the mockup renders
            // at its authored width, then scale to fit the wrap.
            $frame.css({ width: '1440px', 'transform-origin': '0 0' });

            var $wrap = $frame.parent();
            var wrapWidth = $wrap.width();
            var scale = wrapWidth > 0 ? wrapWidth / 1440 : 1;

            $frame.css('transform', 'scale(' + scale + ')');

            // Content-height comes from the mockup itself; keep whatever
            // wrap-height policy the CSS has if we can't read it (sandbox).
            var contentHeight = 0;
            try {
                contentHeight = $frame[0].contentDocument.documentElement.scrollHeight;
            } catch (e) {
                // cross-origin / sandbox — leave the wrap alone
            }

            if (contentHeight > 0) {
                $frame.css('height', contentHeight + 'px');
                // Wrap needs to be tall enough to show the scaled content
                // — otherwise the transform crops it (transform doesn't
                // reflow parent layout).
                $wrap.css('height', Math.ceil(contentHeight * scale) + 'px');
            }
        }

        function tfBindSingleFrames() {
            $('.js-prototype-frame, .js-component-preview-frame').each(function () {
                var frame = this;
                var $frame = $(frame);
                if ($frame.data('tf-fit-bound')) {
                    return;
                }
                $frame.data('tf-fit-bound', true);

                // Fit on load AND once immediately (the frame may have
                // already loaded by the time this binds — .load() alone
                // then never fires).
                $frame.on('load', function () { tfFitSingleFrame($frame); });
                if (frame.contentDocument && frame.contentDocument.readyState === 'complete') {
                    tfFitSingleFrame($frame);
                }
            });
        }

        // Initial pass — DOM ready.
        tfScaleGridPreviews();
        tfBindSingleFrames();

        // ── Rejected drawer toggle ──────────────────────────────
        //
        // Delegated so it survives AJAX tab swaps. The toggle button + its
        // sibling grid live inside .devhub-hub__rejected on the project hub.
        // .is-open on the toggle flips the arrow (CSS handles rotation).
        $(document).on('click', '.js-rejected-toggle', function () {
            var $btn  = $(this);
            var $grid = $btn.siblings('.devhub-hub__rejected-grid');
            var isOpen = $btn.hasClass('is-open');

            if (isOpen) {
                $grid.slideUp(180);
                $btn.removeClass('is-open');
            } else {
                $grid.slideDown(180, function () {
                    // Preview iframes inside the drawer only get their real
                    // width once slideDown finishes — scale them now.
                    tfScaleGridPreviews($grid);
                });
                $btn.addClass('is-open');
            }
        });

        // Rebind after AJAX tab swap so replaced grids get their scale.
        // Also fires on the shell's cross-page nav (tf:shell-navigated) so
        // the mockup iframe on shell-hosted single-design pages picks up
        // its fit after the content pane is swapped in.
        function tfRebindPreviews() {
            tfScaleGridPreviews();
            tfBindSingleFrames();
        }
        document.addEventListener('tf:hub-tab-swapped', tfRebindPreviews);
        document.addEventListener('tf:shell-navigated', tfRebindPreviews);

        // Rescale on viewport resize (debounced) so the fit stays right
        // when the operator resizes the browser.
        var tfResizeTimer = null;
        $(window).on('resize', function () {
            clearTimeout(tfResizeTimer);
            tfResizeTimer = setTimeout(function () {
                tfScaleGridPreviews();
                $('.js-prototype-frame, .js-component-preview-frame').each(function () {
                    tfFitSingleFrame($(this));
                });
            }, 120);
        });

        // ── CPT lightbox (design singles, hub Expand button) ─
        // Bind unconditionally — all internal handlers use $(document).on(...)
        // delegation and look up .js-lightbox at click time. Presence-gating
        // at bind time was fragile against shell-nav swaps and initial page
        // loads where the overlay renders after the ready() tick.
        $('body').devhubCptLightbox();

        // ── Code block tabs ──────────────────────────────────────
        if ($('.js-devhub-tabs').length) {
            $('body').devhubTabs();
        }

        // ── Copy buttons on code blocks ──────────────────────────
        if ($('.js-copy-btn').length) {
            $('body').devhubCopyBtn();
        }

        // ── CPT creation modals ──────────────────────────────────
        if ($('.devhub-modal').length) {
            $('body').devhubCreateModal();
        }

        // ── CPT archive status/delete actions + component code editor ─
        // Bind unconditionally. Every handler inside devhubCptCrud() is a
        // $(document).on(...) delegated binding, so it needs document at
        // bind time, NOT any .devhub-cpt-card. A presence gate here caused
        // Approve/Reject to be silently dead for the life of any session
        // whose initial page load landed on a card-less tab (connections /
        // blocks / pages / wizards) — the plugin never activated and the
        // click handler was never registered, so AJAX-swapping into a card
        // tab afterwards did nothing when the buttons were clicked.
        $('body').devhubCptCrud();

        // ── Brand CSS toggle (single-component) ──────────────────
        if ($('.js-component-preview-frame').length) {
            $('body').devhubBrandToggle();
        }

        // ── Sitemap interactive dashboard ────────────────────────
        if ($('.sitemap-wrap').length) {
            $('.sitemap-wrap').devhubSitemap();
        }

    });

}(jQuery));
